(function () {
  function initGlobalMobileNav() {
    var toggle = document.querySelector("[data-casephon-global-mobile-menu-toggle]");
    var menu = document.getElementById("casephonGlobalMobileMenu");
    var backdrop = document.querySelector(".casephon-global-mobile-menu-backdrop");
    if (!toggle || !menu || !backdrop) return;

    if (backdrop.parentElement !== document.body) document.body.appendChild(backdrop);
    if (menu.parentElement !== document.body) document.body.appendChild(menu);

    document.body.classList.add("casephon-global-mobile-nav-present");

    function openMenu() {
      menu.hidden = false;
      backdrop.hidden = false;
      window.requestAnimationFrame(function () {
        menu.classList.add("is-open");
        backdrop.classList.add("is-open");
        document.body.classList.add("casephon-global-mobile-menu-open");
        toggle.setAttribute("aria-expanded", "true");
        menu.setAttribute("aria-hidden", "false");
      });
    }

    function closeMenu() {
      menu.classList.remove("is-open");
      backdrop.classList.remove("is-open");
      document.body.classList.remove("casephon-global-mobile-menu-open");
      toggle.setAttribute("aria-expanded", "false");
      menu.setAttribute("aria-hidden", "true");
      window.setTimeout(function () {
        if (!menu.classList.contains("is-open")) {
          menu.hidden = true;
          backdrop.hidden = true;
        }
      }, 240);
    }

    toggle.addEventListener("click", function () {
      if (menu.classList.contains("is-open")) closeMenu();
      else openMenu();
    });

    Array.prototype.forEach.call(document.querySelectorAll("[data-casephon-global-mobile-menu-close]"), function (control) {
      control.addEventListener("click", closeMenu);
    });

    Array.prototype.forEach.call(menu.querySelectorAll("a"), function (link) {
      link.addEventListener("click", closeMenu);
    });

    (function () {
      var startX = 0;
      var startY = 0;
      menu.addEventListener("touchstart", function (event) {
        if (!menu.classList.contains("is-open") || !event.touches || !event.touches.length) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });
      menu.addEventListener("touchend", function (event) {
        if (!event.changedTouches || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        if (dx < -62 && Math.abs(dx) > Math.abs(dy) * 1.2) closeMenu();
      }, { passive: true });
    })();

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && menu.classList.contains("is-open")) closeMenu();
    });
  }

  function initProductGalleryVideoFallback() {
    var thumbStack = document.getElementById("thumbStack");
    var videoThumb = thumbStack ? thumbStack.querySelector('.thumb[data-media-type="video"]') : null;
    var productVideo = document.getElementById("productVideo");
    var productImage = document.getElementById("productImage");
    var productStage = productVideo ? productVideo.closest(".product-stage") : null;
    if (!thumbStack || !videoThumb || !productVideo || !productStage) return;

    var videoSrc = videoThumb.getAttribute("data-video-src") || "";
    var posterSrc = videoThumb.getAttribute("data-video-poster") || videoThumb.getAttribute("data-img") || "";
    if (!videoSrc) return;

    function ensureVideoSource(targetVideo) {
      var sourceTag = targetVideo.querySelector("source");
      if (!sourceTag) {
        sourceTag = document.createElement("source");
        sourceTag.type = "video/mp4";
        targetVideo.appendChild(sourceTag);
      }
      if (sourceTag.getAttribute("src") !== videoSrc) sourceTag.setAttribute("src", videoSrc);
      if (posterSrc && targetVideo.poster !== posterSrc) targetVideo.poster = posterSrc;
      targetVideo.muted = true;
      targetVideo.loop = true;
      targetVideo.autoplay = true;
      targetVideo.controls = true;
      targetVideo.preload = "auto";
      targetVideo.setAttribute("playsinline", "");
      targetVideo.setAttribute("webkit-playsinline", "");
    }

    function rebuildVideoNode() {
      var freshVideo = productVideo.cloneNode(false);
      while (freshVideo.firstChild) freshVideo.removeChild(freshVideo.firstChild);
      freshVideo.className = productVideo.className;
      freshVideo.id = productVideo.id;
      freshVideo.removeAttribute("hidden");
      freshVideo.style.display = "block";
      freshVideo.style.width = "100%";
      freshVideo.style.height = "100%";
      freshVideo.style.objectFit = "contain";
      freshVideo.style.background = "rgba(247, 241, 237, 0.98)";
      ensureVideoSource(freshVideo);
      productVideo.replaceWith(freshVideo);
      productVideo = freshVideo;
      return freshVideo;
    }

    function showVideo() {
      var activeVideo = rebuildVideoNode();
      productStage.classList.add("is-video-active");
      activeVideo.removeAttribute("hidden");
      activeVideo.style.display = "block";
      if (productImage) {
        productImage.style.opacity = "0";
        productImage.style.pointerEvents = "none";
      }
      if (!activeVideo.currentSrc || activeVideo.currentSrc.indexOf(videoSrc.replace(/^https?:/, "")) === -1) {
        activeVideo.load();
      }
      var playPromise = activeVideo.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    function hideVideo() {
      productStage.classList.remove("is-video-active");
      productVideo.pause();
      productVideo.setAttribute("hidden", "hidden");
      productVideo.style.display = "none";
      if (productImage) {
        productImage.style.opacity = "";
        productImage.style.pointerEvents = "";
      }
    }

    ensureVideoSource(productVideo);

    videoThumb.addEventListener("click", function () {
      window.requestAnimationFrame(showVideo);
      window.setTimeout(showVideo, 120);
    });

    Array.prototype.forEach.call(thumbStack.querySelectorAll('.thumb:not([data-media-type="video"])'), function (thumb) {
      thumb.addEventListener("click", function () {
        window.requestAnimationFrame(hideVideo);
      });
    });

    productStage.addEventListener("error", function (event) {
      var target = event && event.target;
      if (target && target.tagName === "VIDEO" && posterSrc) target.poster = posterSrc;
    }, true);

    if (videoThumb.classList.contains("is-active")) showVideo();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initGlobalMobileNav();
      initProductGalleryVideoFallback();
    }, { once: true });
  } else {
    initGlobalMobileNav();
    initProductGalleryVideoFallback();
  }
})();
